import { SharedPruefungService } from '@/shared/api/services/pruefungen.ts';

export class PruefungService extends SharedPruefungService {
  async istAuftragErsteller(auftragId: number): Promise<boolean> {
    return this.httpClient.get(`${this.baseUrl}/${auftragId}/AUFTRAG/ist-ersteller`);
  }
}
